import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6.38 6L12 16l5.63-10z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
})), 'DetailsTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DetailsTwoTone.js
// module id = 3117
// module chunks = 2